import { Card, CardContent, Divider, Typography, Button } from '@mui/material'
import { useI18n } from '@ggs/i18n'
import { Box } from '@mui/system'
import { selectSearchResult, useDispatch } from '@ggs/store'

/**
 * @typedef {import('../../../definitions').DealerEntity} DealerEntity
 */

/**
 * @typedef {Object} DealerCardProps
 * @property {DealerEntity} dealer
 * @property {number} listingIndex
 * @property {boolean} isSelected
 */

/**
 * Dealer information card.
 * @param {DealerCardProps} props
 * @return {JSX.Element}
 */
export const DealerCard = ({ dealer, isSelected, listingIndex }) => {
  const { t } = useI18n()
  const tOptions = { nsSeparator: '' }
  const dispatch = useDispatch()

  /**
   * Handle dealer card selection.
   * @param {React.MouseEvent<HTMLButtonElement>} event
   */
  const handleCardSelect = (event) => {
    event.preventDefault()
    const targetElement = event.currentTarget
    const dealerId = targetElement.getAttribute('data-dealer-id')

    if (dealerId) {
      dispatch(selectSearchResult(dealerId))
    }
  }

  const cardId = `dealer-card-${dealer.id}`
  const cardClass = isSelected ? 'dealer-locator__card dealer-locator__card--active' : 'dealer-locator__card'
  return (
    <Box className="dealer-locator__details">
      <Card id={cardId} className={cardClass}>
        <Button
          onClick={handleCardSelect}
          aria-label={t('Select {{name}} dealer', {
            name: dealer.name,
          })}
          data-dealer-id={dealer.id}
        >
          <CardContent className="dealer-locator__card-content">
            <Typography variant={'h3'}>
              #{listingIndex} {dealer.name}
            </Typography>
            <Typography>
              {dealer.address1}
              {dealer.address2}
              <br />
              {dealer.municipality}, {dealer.provinceState} {dealer.postalCode}, {dealer.country}
            </Typography>
            <Divider />
            <Typography>
              <span>{t('T:', tOptions)}</span> {dealer.contactPhone}
            </Typography>
          </CardContent>
        </Button>
      </Card>
    </Box>
  )
}
